import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Dashboard } from "./Dashboard";
import "./App.css";
import "./bootstrap.min.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path={"/"} element={<Dashboard />} />
      </Routes>
    </Router>
  );
}

export default App;
